import React, { FC, useState } from "react";
import { useQuery } from "@apollo/client";
import { ORGANISATIONAL_UNITS_QUERY } from "../graphql/query";
import { FindOrganisationalUnits } from "../graphql/__generated_types__/FindOrganisationalUnits";
import { PracticeAreaTemplateTab } from "@design-system";
import { Template } from "@design-system";
import { LibraryMatterType, usePaginatedMatterQuery } from "../hooks/use-paginated-matter-query";
import { MatterModalTemplateSearch } from "../types";
type Props = {
  onSelect: (template: Template) => void;
  libraryMatterType: LibraryMatterType;
};

export const PracticeAreaTemplateTabContainer: FC<Props> = ({ onSelect, libraryMatterType }) => {
  const [practiceAreaId, setPracticeAreaId] = useState<number | undefined>(undefined);
  const [templateTitle, setTemplateTitle] = useState<string>("");
  const templateSearch = {
    value: templateTitle,
    onChange: setTemplateTitle,
  };
  const { data: organisationalUnitData } = useQuery<FindOrganisationalUnits>(
    ORGANISATIONAL_UNITS_QUERY
  );

  return (
    <TemplateTabData
      setPracticeAreaId={setPracticeAreaId}
      organisationalUnitData={organisationalUnitData}
      onSelect={onSelect}
      libraryMatterType={libraryMatterType}
      defaultPracticeAreaId={practiceAreaId}
      templateSearch={templateSearch}
    />
  );
};

type ListProps = {
  organisationalUnitData: any;
  setPracticeAreaId: (practiceAreaId: number) => void;
  onSelect: (template: Template) => void;
  defaultPracticeAreaId: number | undefined;
};

const TemplateTabData: FC<
  ListProps & { libraryMatterType: LibraryMatterType; templateSearch: MatterModalTemplateSearch }
> = ({
  organisationalUnitData,
  setPracticeAreaId,
  onSelect,
  libraryMatterType,
  defaultPracticeAreaId,
  templateSearch,
}) => {
  const {
    matters,
    count,
    page,
    pageSize,
    loading,
    onChangeTitleSearch,
    onChangePracticeArea,
    onChangePage,
  } = usePaginatedMatterQuery(libraryMatterType, {
    practiceAreaFilter: defaultPracticeAreaId,
  });
  console.log("matters", matters);
  return (
    <PracticeAreaTemplateTab
      items={(matters as unknown as Template[]) || []}
      loading={loading}
      onSelect={onSelect}
      practiceAreas={organisationalUnitData?.organisationalUnits || []}
      onChangePracticeArea={(practiceAreaId) => {
        onChangePracticeArea(practiceAreaId);
        setPracticeAreaId(practiceAreaId);
      }}
      defaultPracticeAreaValue={defaultPracticeAreaId}
      templateSearch={{
        value: templateSearch?.value,
        onChange: (v) => {
          onChangeTitleSearch(v);
          templateSearch?.onChange(v);
        },
      }}
      pagination={{
        current: page,
        onChange: onChangePage,
        total: count || 0,
        defaultPageSize: pageSize,
      }}
    />
  );
};
